import { createAction, handleActions } from 'redux-actions';
import { flow, head, find, get } from 'lodash';
import fetch from 'isomorphic-fetch';

const NAMESPACE = 'cgs/location';
const ns = name => `${NAMESPACE}/${name}`;
const createActionWithNS = flow(ns, createAction);

const locationLookupSend = createActionWithNS('SEND');
const locationLookupReceive = createActionWithNS('RECEIVE');
const locationLookupError = createActionWithNS('FAILED');

const initialState = {
  isDoing: false,
  error: false,
  rawLocationData: null,
  zipCode: null,
  state: null,
  country: null,
};

const findResult = results => name =>
  get(
    find(
      results,
      obj => obj.types[0] === name && obj.types[1] === 'political',
    ),
    'short_name', null);

// Map alpha2 code to preferred Cummins country result
const mapCountryCode = (CountryCode) => {
  switch (CountryCode) {
    case 'CA':
      return 'Canada';
    case 'US':
      return 'USA';
    default:
      return CountryCode;
  }
};

export const reducer = handleActions({
  [locationLookupSend]: (state, { payload }) => ({
    ...initialState,
    zipCode: payload,
    isDoing: true,
  }),
  [locationLookupError]: (state, { error }) => ({
    ...initialState,
    error,
  }),
  [locationLookupReceive]: (state, { payload }) => {
    const addressComponents = get(payload, 'address_components', []);
    const getComponent = findResult(addressComponents);
    return {
      ...state,
      rawLocationData: payload,
      state: getComponent('administrative_area_level_1'),
      country: mapCountryCode(getComponent('country')),
    };
  },
}, initialState);

const base = 'https://maps.googleapis.com/maps/api/geocode/json';
export const fetchLocationData = zipCode => (dispatch, getState) =>
  getState().location.zipCode !== zipCode &&
  dispatch(locationLookupSend(zipCode)) &&
  fetch(`${base}?address=${zipCode}&key=${process.env.REACT_APP_HOMEGEN_GOOGLE_API_KEY}`)
    .then(res => res.json())
    .then(res => (res.status === 'OK' && res.results.length
      ? dispatch(locationLookupReceive(head(res.results)))
      : dispatch(locationLookupError(new Error('Bad entry')))))
    .catch(error => dispatch(locationLookupError(error.message)));



// WEBPACK FOOTER //
// ./src/redux-modules/location.js